// extracted by mini-css-extract-plugin
export default {"syncOverview":"syncOverview__k1EWx","errorTitle":"errorTitle__q1dir","errorContainer":"errorContainer__f1Zw1","errorText":"errorText__Zd1RV"};